export const getActualDate = () => {
    const date = new Date();

    let day = date.getDate();
    // @ts-ignore
    if (day < 10) day = `0${day}`;

    let month = date.getMonth() + 1;
    // @ts-ignore
    if (month < 10) month = `0${month}`;

    const year = date.getFullYear();
    // const hours = date.getHours();
    // const minutes = date.getMinutes();

    return `${year}-${month}-${day}`;
};

export const deleteExtraSpaces = (text) => {
    return text.trim().replace(/ +(?= )/g, '');
};
